import moment from 'moment'

export default {
    install (Vue) {
        Vue.filter('date', (date, format = 'YYYY.MM.DD') => moment(date).format(format))
        Vue.filter('dateBig', (date, format = 'YYYY年MM月DD日') => moment(date).format(format))
        Vue.filter('month', (date, format = 'YYYY.MM') => moment(date).format(format))
        Vue.filter('datetime', (date, format = 'YYYY-MM-DD HH:mm') => moment(date).format(format))
        Vue.filter('datetimeBig', (date, format = 'YYYY年MM月DD日 HH:mm') => moment(date).format(format))
        Vue.filter('age', date => moment().diff(date, 'years'))
        Vue.filter('unit', (text, unit) => text && text + unit)
        Vue.filter('split', (text = '', separator = ' ') => text.split(separator))
        Vue.filter('join', (array = '', separator = ' ') => array.join(separator))
        Vue.filter('trimspace', (text = '') => text.replace(/\s/g, ''))
        Vue.filter('abs', (number) => Math.abs(number))
        Vue.filter('thumb', (url, width = 200, height) => url && `${url}?x-oss-process=image/resize,m_fill,w_${width},h_${height || width}`)
        Vue.filter('money', (money) => +money / 100)
        Vue.filter('phone', (value) => String(value.substring(0,3)+"******"+value.substring(value.length-2)))
        Vue.filter('userName', (value) => String(value.substring(0,1)+"**"))
        Vue.filter('switchRate', (score) => (+score / 20) * 0.75)
        Vue.filter('padStart', (value) => String(value).padStart(3, '0'))//报到号码过滤器 001
    }
}
